import { Component, Input, OnInit, signal } from '@angular/core';
import { Finishing, PageSize } from 'src/app/shared-lib/core/settings';
import { PrintingGroup, ProductService } from 'src/app/shared-lib/domains/product';
import { FileService } from 'src/app/shared/file.service';
import { UtilsService } from 'src/app/shared/services/utils.service';

@Component({
  selector: 'app-file-details',
  templateUrl: './file-details.component.html',
  styleUrls: ['./file-details.component.scss'],
  standalone: false
})
export class FileDetailsComponent implements OnInit {

  @Input() file;
  @Input() printingGroup: PrintingGroup;

  viewDetails: boolean = false;
  withoutStock: { [fileId: string]: { ringColor: boolean, hardCoverFront: boolean, hardCoverBack: boolean; }; } = {};
  finishing = Finishing;
  coverSettings: any;
  printSettings;
  showCovers = signal<boolean>(false);

  constructor(
    public utils: UtilsService,
    public fileService: FileService,
    private productService: ProductService
  ) {
  }

  ngOnInit() {
    this.coverSettings = this.fileService.getCoverSettings();
    this.printSettings = this.printingGroup.printSettings;
    this.showCovers.set(this.printSettings.finishing !== Finishing.BINDING_LAMINATED && this.printSettings.pageSize !== PageSize.A3);
  }

  get warningMessage() {
    return this.productService.getWarningMessage(this.printingGroup);
  }

  toggleViewDetails() {
    this.viewDetails = !this.viewDetails;
  }

  bindingOptionValueForFile(option, param) {
    let ret;
    switch (option) {
      case 'ringColor':
        if (param === 'id')
          ret = this.file.ringColor?.id;
        if (param === 'name')
          ret = this.file.ringColor?.name;
        break;
      case 'hardCoverFront':
        if (param === 'id')
          ret = this.file.hardCoverFront?.id;
        if (param === 'name')
          ret = this.file.hardCoverFront?.name;
        if (param === 'color')
          ret = this.file.hardCoverFront?.color;
        break;
      case 'hardCoverBack':
        if (param === 'id')
          ret = this.file.hardCoverBack?.id;
        if (param === 'name')
          ret = this.file.hardCoverBack?.name;
        if (param === 'color')
          ret = this.file.hardCoverBack?.color;
        break;
    }

    return ret;
  }

  getCoverTypeSetting(file) {
    let setting = this.coverSettings.find(setting => setting.value.id === file.coverType.id);
    return setting;
  }

  protected readonly Finishing = Finishing;
}
